//192.168.1.148:8302/api/publishing-house/order/import

import axios from "axios";
/**
 * 获取订单详情
 */
export const OrderDetail = async <T>(params: {
  order_id: string;
  sign: string;
}) => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/order/detail",
    params
  );
  return result.data;
};

/**
 * 发送合并订单授权验证码
 * @param params
 * @returns
 */
export const sendMergeVerifyCode = async <T>(params: { order_id: string }) => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/order/send-merge-verify-code",
    params
  );
  return result.data;
};

/**
 * 查询可合并订单
 * @param params
 * @returns
 */
export const queryMergeOrder = async <T>(params: {
  order_id: string;
  verify_code: string;
}) => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/order/query-merge-order",
    params
  );
  return result.data;
};

/**
 * 提交订单
 */
export const commitOrder = async <T>(params: {
  bill?: InvoiceInfo & InvoiceAddress;
  order_ids: Array<string>;
  pay_money: Array<number>;
}) => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/transaction/commit",
    params
  );
  return result.data;
};

/**
 * 提交拆分订单
 */
export const splitOrder = async <T>(params: {
  order_id: string;
  orders: Array<SplitMoney>;
  pay_money: number;
}) => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/order/split",
    params
  );
  return result.data;
};

// 提交定购订单
//https://pubadmin.dev.kxsz.net/api/pay/order/create-pod-order

export const createPodOrder = async <T>(params: {
  bill?: InvoiceInfo & InvoiceAddress;
  apc_order_id: string;
  // pod版本类型 1：黑白版 2：彩色版
  type: number;
  number: number;
  receive: {
    //  收件人地址;
    address: string;
    //收件人
    contact: string;
    // 电话
    phone: string;
  };
}) => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/order/create-pod-order",
    params
  );
  return result.data;
};

/**
 * 微信支付，返回用于生成二维码的链接
 */
export const wxPay = async <T>(params: { transaction_id: string }) => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/transaction/wechat",
    params
  );
  return result.data;
};

/**
 * 微信 H5 支付，返回手机支付链接
 */
export const wxH5Pay = async <T>(params: { transaction_id: string }) => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/transaction/wechat-h5",
    params
  );
  return result.data;
};

/**
 * 通联支付二维码
 * pay_type：1 支付宝，2 微信，3 银联
 */
export const allInPayQrcode = async <T>(params: {
  transaction_id: string;
  pay_type: 1 | 2 | 3;
}) => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/transaction/all-in-pay-qrcode",
    params
  );
  return result.data;
};

/**
 * 通联 APP 支付，返回需要在新标签页打开的跳转地址
 * pay_type：1 支付宝，2 微信，3 银联
 */
export const allInPayApp = async <T>(params: {
  transaction_id: string;
  pay_type: 1 | 2 | 3;
}) => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/transaction/all-in-pay-app",
    params
  );
  return result.data;
};

/**
 * 通联 H5 网关，返回跳转地址和需要浏览器 POST 的表单字段。仅移动端银联使用
 */
export const allInPayH5 = async <T>(params: { transaction_id: string }) => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/transaction/all-in-pay-h5",
    params
  );
  return result.data;
};

/**
 * 通联银行卡支付，返回跳转地址和需要浏览器 POST 的表单字段
 */
export const allInPayCard = async <T>(params: { transaction_id: string }) => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/transaction/all-in-pay-card",
    params
  );
  return result.data;
};

/**
 * 支付状态查询
 */
export const queryPayStatus = async <T>(params: { transaction_id: string }) => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/transaction/query",
    params
  );
  return result.data;
};

/**
 * 支付结果查询
 */
export const queryPayComplete = async <T>(params: {
  transaction_id: string;
}) => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/transaction/complete",
    params
  );
  return result.data;
};

/**
 * 支付宝回调之后数据库同步订单状态
 */
export const queryAlipay = async <T>(params: { [key: string]: unknown }) => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/callback/alipay",
    params
  );
  return result.data;
};
/**
 * 线下支付
 * @param params
 * @returns
 */
export const offlinePay = async <T>(params: { transaction_id: string }) => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/transaction/bank-transfer",
    params
  );
  return result.data;
};

/**
 * 根据订单id获取支付方式列表
 */
export const getPayMethod = async <T>(params: { order_id: string }) => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/order/get-pay-method",
    params
  );
  return result.data;
};

/**
 * 取消pod订单
 */
export const cancelPodOrder = async <T>(params: { order_id: string }) => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/user-center/cancel-pod-order",
    params
  );
  return result.data;
};

/**
 * 确认pod订单收货
 */
export const markPodOrderReceipt = async <T>(params: { order_id: string }) => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/user-center/mark-pod-order-deliver-complete",
    params
  );
  return result.data;
};
